/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type {
  Signer,
  AddressLike,
  ContractDeployTransaction,
  ContractRunner,
} from "ethers";
import type { NonPayableOverrides } from "../../common";
import type {
  EmergencyGovernance,
  EmergencyGovernanceInterface,
} from "../../contracts/EmergencyGovernance";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "emergencyUpgraderAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "EmergencyUpgradesDisabled",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "InvalidEmergencyUpgraderAddress",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "OwnableInvalidOwner",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "OwnableUnauthorizedAccount",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [],
    name: "Disabled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "oldEmergencyUpgrader",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "newEmergencyUpgrader",
        type: "address",
      },
    ],
    name: "EmergencyUpgraderChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferStarted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [],
    name: "acceptOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "disable",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "disabled",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "emergencyUpgrader",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pendingOwner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newEmergencyUpgrader",
        type: "address",
      },
    ],
    name: "setEmergencyUpgrader",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type EmergencyGovernanceConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: EmergencyGovernanceConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class EmergencyGovernance__factory extends ContractFactory {
  constructor(...args: EmergencyGovernanceConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    emergencyUpgraderAddress: AddressLike,
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(
      emergencyUpgraderAddress,
      overrides || {}
    );
  }
  override deploy(
    emergencyUpgraderAddress: AddressLike,
    overrides?: NonPayableOverrides & { from?: string }
  ) {
    return super.deploy(emergencyUpgraderAddress, overrides || {}) as Promise<
      EmergencyGovernance & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(
    runner: ContractRunner | null
  ): EmergencyGovernance__factory {
    return super.connect(runner) as EmergencyGovernance__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): EmergencyGovernanceInterface {
    return new Interface(_abi) as EmergencyGovernanceInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): EmergencyGovernance {
    return new Contract(
      address,
      _abi,
      runner
    ) as unknown as EmergencyGovernance;
  }
}
